import React from 'react';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { ClosingDateNotice } from './ClosingDateNotice';

export const ClosingDateGuidanceAlert = () => (
    <ClosingDateNotice
        tone="info"
        icon={faInfo}
        className="closing-date-guidance-alert">
        We recommend discussing with your counsel before proposing or accepting
        a date, and confirming your full team can support any date you accept.
    </ClosingDateNotice>
);
